import { gql } from 'graphql-tag'
import { chainSettingFragment } from '../admin/chain/chainSettings/chainSettingsQueries'
import { vitrineProductFragment } from '../admin/vitrineProduct/vitrineProductQueries'
import { customerTargetFragment } from '../customerTarget/customerTargetQueries'

const vitrineProductTargetItemFragment = gql`
  fragment VitrineProductTargetItemFragment on VitrineProductTargetItem {
    timeslot
    target
    readyNow
    estimate
    toBeMade
  }
`

const vitrineProductTargetFragment = gql`
  fragment VitrineProductTargetFragment on VitrineProductTarget {
    product {
      ...VitrineProductFragment
    }
    targets {
      ...VitrineProductTargetItemFragment
    }
  }
  ${vitrineProductFragment}
  ${vitrineProductTargetItemFragment}
`

export const vitrineProductTargets = gql`
  query VitrineProductTargets(
    $stationId: ID!
    $productType: ProductType!
    $vitrineProductType: VitrineProductEnumType
    $date: String!
    $name: String
  ) {
    customerTargets(stationId: $stationId, fromDate: $date, toDate: $date, productType: $productType) {
      ...CustomerTargetFragment
    }
    chainSetting(name: $name) {
      ...ChainSettingFragment
    }
    vitrineProductTargets(stationId: $stationId, productType: $vitrineProductType, date: $date) {
      ...VitrineProductTargetFragment
    }
  }
  ${customerTargetFragment}
  ${chainSettingFragment}
  ${vitrineProductTargetFragment}
`

export const upsertVitrineProductTarget = gql`
  mutation upsertVitrineProductTarget(
    $stationId: ID!
    $vitrineProductId: ID!
    $date: String!
    $timeslot: String!
    $readyNow: Int!
    $toBeMade: Int
  ) {
    upsertVitrineProductTarget(
      stationId: $stationId
      vitrineProductTarget: {
        vitrineProductId: $vitrineProductId
        date: $date
        timeslot: $timeslot
        readyNow: $readyNow
        toBeMade: $toBeMade
      }
    ) {
      ...VitrineProductTargetFragment
    }
  }
  ${vitrineProductTargetFragment}
`
